<script>
	export let name;
	export let label = '';
	export let checked;
	export let small = false;
	export let className = 'mr-2';
	export let disabled = undefined;

	const clickedSwitch = () => {
		checked = !checked;
	};
</script>

<div
	class="relative inline-block {small
		? 'w-6'
		: 'w-10'} align-middle transition duration-200 ease-in select-none {className}"
	role="switch"
	class:opacity-60={disabled}
	aria-checked={checked}
	tabindex="-1"
	on:click|self|stopPropagation|capture={clickedSwitch}
>
	<input
		bind:checked
		class="absolute block {small
			? 'w-4 h-4'
			: 'w-6 h-6'} bg-white border-2 border-gray-300 rounded-full appearance-none cursor-pointer toggle-checkbox focus:outline-none select-none"
		class:opacity-60={disabled}
		{disabled}
		id={name}
		{name}
		on:change
		on:input
		type="checkbox"
	/>
	<label
		class=" block {small
			? 'h-4'
			: 'h-6'} overflow-hidden bg-gray-300 rounded-full cursor-pointer toggle-label flex flex-row items-center select-none"
		for={name}
	>
		{label ?? ''}
	</label>
</div>

<style>
	.toggle-checkbox:checked {
		right: 0;
		border-color: #68d391;
	}

	.toggle-checkbox:checked + .toggle-label {
		background-color: #68d391;
	}
</style>
